import script from "./AdminProductTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductTable.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductTable.vue?vue&type=style&index=0&id=3ed3783e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ed3783e"]])

export default __exports__